import './assets/css/sb-admin-2.min.css'

export default {
}